module.exports = __webpack_public_path__ + "assets/49dcfa2f3fcb90f13d0973dc1216eba9.png";